import React, { ChangeEvent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { AppState, IPageState } from './../appredux';
import { ThemeProvider, withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, FormControl, Select, MenuItem, TextField } from '@material-ui/core';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';
import theme from './../themes';



interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,

    open: boolean,
    close: () => void,
    title: string,
    text: string,
}

interface DialogState {
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {
   
    render() {
        const classes = this.props.classes;

        let tablet = this.props.page.tablet

        return (
            <Dialog
            maxWidth="xs"
            open={this.props.open}
            onEscapeKeyDown={this.props.close}
            onBackdropClick={this.props.close}
            style={{zoom: tablet? "1.2" : "1"}}
            fullWidth
        >
            <DialogTitle disableTypography style={{}}>
                <Typography gutterBottom variant="h6" component="h2" color='primary'
                    className={`${classes.headline}`}><b style={{ }}>{this.props.title}</b>
                </Typography>
                <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
            </DialogTitle>
            <DialogContent>
              <DialogContentText className={classes.dialogContentText} >
                {this.props.text}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" size="small" className={classes.button}
                    onClick={this.props.close}>
                    <b>wróć</b>
                </Button>
            </DialogActions>
        </Dialog>
        );
    }
}

const styles = (theme: Theme) => ({
    headline: {
        lineHeight: "20px",
      },
      dialogContentText: {
        //color: theme.palette.text.secondary,
        color: theme.palette.primary.main,
        whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px'
      },
      button: {
        textTransform: "none" as "none"
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

